import * as React from "react";

interface PageTitleContextValue {
  title: string | null;
  subtitle: string | null;
  setTitle: (title: string | null) => void;
  setSubtitle: (subtitle: string | null) => void;
}

const PageTitleContext = React.createContext<PageTitleContextValue>({
  title: null,
  subtitle: null,
  setTitle: () => {},
  setSubtitle: () => {}
});

export function PageTitleProvider({ children }: { children: React.ReactNode }) {
  const [title, setTitle] = React.useState<string | null>(null);
  const [subtitle, setSubtitle] = React.useState<string | null>(null);

  const value = React.useMemo(
    () => ({ title, subtitle, setTitle, setSubtitle }),
    [title, subtitle]
  );

  return (
    <PageTitleContext.Provider value={value}>
      {children}
    </PageTitleContext.Provider>
  );
}

export function usePageTitle(title: string, subtitle?: string) {
  const ctx = React.useContext(PageTitleContext);
  React.useEffect(() => {
    ctx.setTitle(title);
    if (subtitle !== undefined) ctx.setSubtitle(subtitle);
    return () => {
      ctx.setTitle(null);
      ctx.setSubtitle(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, subtitle]);
}

export function usePageTitleValue() {
  const ctx = React.useContext(PageTitleContext);
  return { title: ctx.title, subtitle: ctx.subtitle };
}
